import React from 'react';
import './Backdrop.scss';
import classnames from 'classnames';

const backdrop = (props) => (
    <div className={classnames('Backdrop', props.className, props.show ? '' : 'hidden')} onClick={props.clicked}>
      {props.children}
    </div>
)

export default backdrop
